import { defineComponent, ref } from 'vue';
import { OnClickOutside } from '@vueuse/components';
import Image from '@hems/component/src/image/Image2.vue';
export default defineComponent({
    name: 'MultiListDropdown',
    components: {
        Image,
        OnClickOutside,
    },
    props: {
        dropdownList: {
            type: Array,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        iconSrc: {
            type: String,
            required: true,
        },
    },
    emits: ['select'],
    setup(props, { emit }) {
        const isShowMenu = ref(false);
        const onClickOutside = () => {
            isShowMenu.value = false;
        };
        const onClickDropdownButton = () => {
            isShowMenu.value = !isShowMenu.value;
        };
        const onSelectMenu = (label) => {
            emit('select', label);
            onClickOutside();
        };
        return {
            isShowMenu,
            onClickOutside,
            onClickDropdownButton,
            onSelectMenu,
        };
    },
});
